export default class RandomString {

  static upperCharSet: string[] = [
    'B', 'C', 'D', 'F', 'G',   'H', 'J', 'K', 'M', 'N',
    'P', 'Q', 'R', 'S', 'T',   'V', 'W', 'X', 'Y', 'Z',
    '2', '3', '4', '5', '6',   '7', '8', '9'
  ];

  static generateUpperCase(length: number): string {
    return this.generate(length, this.upperCharSet);
  }

  static generate(length: number, set: string[]): string {
    if ( length < 1 ) {
      return '';
    }
    let sb = set[this.randomInt(set.length - 8)]; // ensure first char is not a digit
    for (let i = 1; i < length; i++ ) {
      sb = sb + set[this.randomInt(set.length)];
    }
    return sb;
  }

  static randomInt(max: number): number {
    return Math.floor(Math.random() * Math.floor(max));
  }

  static inCharSet(c: string): boolean {
    for ( const s of this.upperCharSet ) {
      if ( s === c ) {
        return true;
      }
    }
    return false;
  }

}
